cb.define([], function () {
  var PC_pc_spepro_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      viewmodel.get("userdefinespecs") && viewmodel.get("userdefinespecs").on("afterSetActionsState", function (states) {
        let mode = viewmodel.getParams().mode;
        if (mode == 'browse') {
          states.map(val => val.cmdeleteRow.visible = false)
        } else {
          states.map(val => val.cmdeleteRow.visible = true)
        }
      });

      //删除规格值之前进行验证
      viewmodel.on('beforeDeleteRow', function (args) {
        let gridModel = viewmodel.getGridModel()
        let row = gridModel.getRow(args.params.params.index);
        var proxy = cb.rest.DynamicProxy.create({ ensure: { url: "/product/tpl/userdef/refcheck", method: "POST" } });
        var params = { billnum: "pc_spepro", id: row.id, data: row }
        proxy.ensure(params, function (err, result) {
          if (err) { cb.utils.alert(err.message, 'error'); return }
          if (result != undefined && 1 != result.deleteFlag) { //不为1，不允许删除
            cb.utils.alert('规格值被商品模板引用，无法删除！', 'warning');
          } else {
            gridModel.deleteRows(args.params.params.index);
          }
        });
        return false;
      })
      viewmodel.get('userdefinespecs') && viewmodel.get('userdefinespecs').getEditRowModel().get('orderNum').setState('min', 0)
      const diffdisabled = () => {
        let mode = viewmodel.getParams().mode;
        // 如果被引用 则设置不可编辑
        let _args = viewmodel.getAllData();
        let filterArr = ['id', 'checkPro'];
        if (mode != 'add' && _args.checkPro) {
          if (_args.checkPro.checkHead == 1) {
            Object.keys(_args).forEach(val => {
              if (filterArr.indexOf(val) < 0 && typeof _args[val] !== 'object' && val == 'isShowSpec') viewmodel.get(val).setReadOnly(true)
            })
          }
          let userdefinespecsModel = viewmodel.getGridModel();
          if (_args.checkPro.checkBody.length) {
            let userdefinespecsList = userdefinespecsModel.getAllData();
            userdefinespecsList.forEach((val, index) => {
              if (_args.checkPro.checkBody.indexOf(val.id) >= 0) userdefinespecsModel.setCellState(index, 'name', 'readOnly', true)
            })
          }
        }
      }
      viewmodel.on('afterEdit', () => diffdisabled())
      viewmodel.on('afterLoadData', function () {
        let mode = viewmodel.getParams().mode;
        if (mode == 'browse') diffdisabled()
      })
    }
  }
  try {
    module.exports = PC_pc_spepro_VM_Extend;
  } catch (error) {
    // 当 类型 为 档案 的时候
  }
  return PC_pc_spepro_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_spepro_VM.Extend.js